import React from "react";

const ARRAIGO_URL =
  "https://arraigodigital.com?utm_source=burning-pablo&utm_medium=footer&utm_campaign=powered-by";

export default function PoweredBy() {
  return (
    <a
      href={ARRAIGO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="powered-by"
      aria-label="Powered by Arraigo Digital"
    >
      <span className="powered-by__mark" aria-hidden="true">
        <img
          src="/images/arraigo-digital-logo.png"
          alt=""
          className="powered-by__logo"
        />
      </span>

      <span className="powered-by__content">
        <span className="powered-by__label">Powered by</span>
        <span className="powered-by__brand">
          Arraigo Digital
          <i
            className="fa-solid fa-arrow-up-right powered-by__arrow"
            aria-hidden="true"
          />
        </span>
      </span>
    </a>
  );
}
